import React from 'react'

export default function Modal({title, onClose, children}) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 10,
          border: '1px solid #E5E7EB',
          padding: '1.5rem',
          width: 600,
          maxWidth: '95vw',
          maxHeight: '88vh',
          overflowY: 'auto',
          boxSizing: 'border-box',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '1.25rem',
          }}
        >
          <h2 style={{margin: 0, fontSize: 15, fontWeight: 600, color: '#111'}}>
            {title}
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: 20,
              cursor: 'pointer',
              color: '#9CA3AF',
            }}
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  )
}
